import React, { useState, useEffect, useRef } from 'react';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import ComboSelector, { TipoClave } from '../UI/campos/ComboSelector.js';
import MensajeError from '../UI/MensajeError.js';

const SelectParametro = (props) => {
  const estilo = props.estilo;
  const tipoParametro = props.tipoParametro;
  const tipoObjeto = props.tipoObjeto;
  const itemActual = props.valor;
  const codigoPorDefecto = props.codigoPorDefecto;
  const allowedCodigos = props.allowedCodigos;
  const dropUp = props.dropUp;
  const campoDescripcion = props.campoDescripcion || 'descripcion';
  const [lista, setLista] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const path = tipoParametro && tipoParametro.path;

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  // keep a ref to fetchData so its changing identity doesn't retrigger this effect
  const fetchDataRef = useRef(fetchData);
  useEffect(() => {
    fetchDataRef.current = fetchData;
  }, [fetchData]);

  useEffect(() => {
    const handleLista = (data) => {
      if (allowedCodigos && allowedCodigos.length > 0) {
        setLista((data || []).filter((d) => allowedCodigos.includes(d.codigo)));
      } else {
        setLista(data || []);
      }
    };

    if (path) {
      if (tipoObjeto) {
        fetchDataRef.current(path + '?tipoObjeto=' + tipoObjeto, handleLista);
      } else {
        fetchDataRef.current(path, handleLista);
      }
    }
    // intentionally not including fetchData in deps because its identity may change each render
  }, [path, tipoObjeto, allowedCodigos]);

  const onParametroElegido = (parametroElegido) => {
    props.onChange(parametroElegido);
  };

  // Buscar el item en la lista según el valor actual o el código por defecto
  const getItemSeleccionado = () => {
    // Si ya hay un item actual completo, usarlo
    if (itemActual && typeof itemActual === 'object' && itemActual.codigo !== undefined) {
      return itemActual;
    }

    // Si no hay item actual pero hay un código por defecto y la lista está cargada
    if (!itemActual && codigoPorDefecto !== undefined && lista.length > 0) {
      const itemEncontrado = lista.find((item) => item.codigo === codigoPorDefecto);
      if (itemEncontrado) {
        // Notificar al padre que se seleccionó este item por defecto
        // Pero solo la primera vez que se carga la lista
        props.onChange(itemEncontrado);
        return itemEncontrado;
      }
    }

    // Si itemActual es un código primitivo (número o string), buscar en la lista
    if (
      itemActual !== null &&
      itemActual !== undefined &&
      typeof itemActual !== 'object' &&
      lista.length > 0
    ) {
      const itemEncontrado = lista.find((item) => item.codigo === itemActual);
      if (itemEncontrado) {
        return itemEncontrado;
      }
    }

    return null;
  };

  const getValorActual = () => {
    const item = getItemSeleccionado();
    if (!item) return '';
    console.log('SelectParametro:', campoDescripcion, item);
    // Si campoDescripcion es 'nombre', intentar usar nombre, si no existe usar descripcion
    if (campoDescripcion === 'nombre') {
      return item.nombre || item.descripcion || '';
    }
    return item.descripcion || '';
  };

  return (
    <React.Fragment>
      <ComboSelector
        estilo={estilo}
        lista={lista}
        valorActual={getValorActual()}
        campoClave={TipoClave.CODIGO}
        campoDescripcion={campoDescripcion}
        isCargando={isCargando}
        dropUp={dropUp}
        onItemElegido={onParametroElegido}
      />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default SelectParametro;
